<div class="delete-lead-container">

  <div class="header">
    <div fiTranslation="BUTTON_DELETE_LEAD"></div>
    <fi-button
      variant="tertiary"
      tone="neutral"
      size="lg"
      [iconOnly]="true"
      (click)="closeDialog()"
    >
      <mat-icon fiButtonIcon>close</mat-icon>
      <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
    </fi-button>
  </div>

  <div class="main-container">
    <div class="form">
      <div class="form-title" fiTranslation="ACTION_DELETE_HEADLINE_DELETE"></div>
      @if (errorMassage !== '') {
        <div class="error-massage" fiTranslation="ERROR_ACTION_DELETE">{{errorMassage}}</div>
      }
    </div>
  </div>

  <div class="footer">
    <button (click)="onDeleteRequest()">
      <img src="/assets/icons/new/trash-light.svg" alt="Action icon">
      <span fiTranslation="BUTTON_DELETE_LEAD"></span>
    </button>
  </div>

</div>
